export { columns, getLocationDataFromResponse, LocationTable } from './columns';
